module.exports = __webpack_public_path__ + "img/en.5638bbd9.svg";